const API_ROUTES_NELO_MSS = '/api/nelo/mss';
const APP_CHECK_DISABLED = '__APP_CHECK_DISABLED__';
const MSS_CODE = {
  애플리케이션변조: 64,
  TEE: 32,
  잠금여부: 16,
  USIM여부: 8,
  알림활성화여부: 4,
  버전: 2,
  팝업노출여부: 1
};
const ERROR_CODE = {
  성공: 1000,
  미지원_OS: 1001,
  유심_없음: 1002,
  기기_탈옥_또는_변조: 1003,
  알림_비활성화: 1004,
  미잠금: 1005,
  /**
   * @description TEE: https://en.wikipedia.org/wiki/Trusted_execution_environment
   */
  TEE_없음: 1006,
  알수없음: 9999
};

export { API_ROUTES_NELO_MSS, APP_CHECK_DISABLED, ERROR_CODE, MSS_CODE };
